<template>
  <div class="drawer">
    <el-drawer
      size="700px"
      title="入库详情"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <div style="line-height: 44px">
        <el-row
          style="font-size: 12px; color: #333; border-bottom: 1px solid #f2f2f2"
        >
          <el-col :span="8">
            <span class="label">入库单号：</span>
            <span class="value">
              {{ detail.inOrderNo }}
            </span>
          </el-col>
          <el-col :span="8">
            <span class="label">入库员：</span>
            <span class="value">
              {{ detail.approveUserName }}
            </span>
          </el-col>
          <el-col :span="8">
            <span class="label">入库日期：</span>
            <span class="value">
              {{ this.$public.FTime(detail.inDate) }}
            </span>
          </el-col>
        </el-row>
        <el-row
          style="font-size: 12px; color: #333; border-bottom: 1px solid #f2f2f2"
        >
          <el-col :span="8">
            <span class="label">入库类型：</span>
            <span class="value">
              {{ detail.inOrderType && detail.inOrderType.name }}
            </span>
          </el-col>
          <el-col :span="8">
            <span class="label">来源门店：</span>
            <span class="value">
              {{ detail.otherShopName }}
            </span>
          </el-col>
          <el-col :span="8">
            <span class="label">状态：</span>
            <span class="value">
              <span v-if="detail.acceptStatus == 0">未验收</span>
              <span v-else-if="detail.acceptStatus == 1">部分验收</span>
              <span v-if="detail.acceptStatus == 2">验收完成</span>
              <span v-if="detail.approveStatus && detail.approveStatus.id == 2">
                且审批完成</span
              >
            </span>
          </el-col>
        </el-row>
        <el-row
          style="font-size: 12px; color: #333; border-bottom: 1px solid #f2f2f2"
        >
          <el-col :span="24">
            <span class="label">备注：</span>
            <span class="value">
              {{ detail.remark }}
            </span>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column type="expand" width="30">
            <template slot-scope="props">
              <div>
                <div v-if="!$public.isNull(props.row.goodsItem)">
                  <el-tag
                    style="margin: 5px"
                    v-for="item in props.row.goodsItem"
                    :type="item.acceptCount != 0 ? 'success' : 'info'"
                    :key="item.tableKey"
                  >
                    {{ item.customCode }}
                  </el-tag>
                </div>
                <div v-else>无条码</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="名称">
            <template slot-scope="props">
              {{ props.row.goodsName }}
            </template>
          </el-table-column>
          <el-table-column label="规格">
            <template slot-scope="props">
              <span>{{ props.row.skuValue }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="60">
            <template slot-scope="props">
              <span>{{ props.row.unit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数量" width="60">
            <template slot-scope="props">
              {{ props.row.goodsItem.length }}
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
            v-if="detail.inOrderType && detail.inOrderType.id == 3"
          >
            <template slot-scope="props">
              <span v-if="props.row.count == props.row.acceptCount">
                <span style="color: #13ce66">•</span>
                已验收 {{ props.row.acceptCount }} / {{ props.row.count }}
              </span>
              <span
                v-if="
                  props.row.count > props.row.acceptCount &&
                  props.row.acceptCount != 0
                "
              >
                <span style="color: #e6a23c">•</span>
                部分验收 {{ props.row.acceptCount }} / {{ props.row.count }}
              </span>
              <span v-if="props.row.acceptCount == 0">
                <span style="color: #e6a23c">•</span>
                未验收 {{ props.row.acceptCount }} / {{ props.row.count }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawerStatus: false,
      detail: {},
      tableData: [],
    };
  },
  props: {
    id: {
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
      this.getDetail();
    });
  },
  methods: {
    handleClose() {
      this.$emit("submit");
    },
    // 提交
    getDetail() {
      let params = {
        orderId: this.id,
      };
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_Url3 + "api/Warehouse/InOrder/detail", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.detail = res.data;
            this.tableData = this.sumGoods(this.detail.inOrderItems);
            console.log(this.tableData, "this.tableData");
          }
        });
    },
    sumGoods(arry) {
      let sumData = [];

      arry.forEach((item) => {
        let index = sumData.findIndex((ele) => {
          return item.goodsId == ele.goodsId && item.skus == ele.skus;
        });

        if (index == -1) {
          sumData.push({
            goodsId: item.goodsId,
            goodsName: item.goodsName,
            count: item.count,
            acceptCount: item.acceptCount,
            skus: item.skus,
            skuValue: item.skuValue,
            unit: item.unit,
            goodsItem: [item],
          });
        } else {
          sumData[index].acceptCount += item.acceptCount;
          sumData[index].count += item.count;
          sumData[index].goodsItem.push(item);
        }
      });
      return sumData;
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .label {
      display: inline-block;
      width: 100px;
      text-align: right;
      flex-shrink: 0;
      line-height: 24px;
    }
    .value {
      line-height: 24px;
    }
  }
}
</style>
